import React, { useState } from 'react';
import { Collapse, Table, Tag, Checkbox, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { ObserveRadarEntry } from '../../../../services/devApi';

const { Text } = Typography;

interface Props {
  radar: ObserveRadarEntry[];
}

function renderMark(record: ObserveRadarEntry): React.ReactNode {
  if (record.isWhitelisted) return <Tag color="blue">白名單</Tag>;
  if (record.isNoise) return <Tag color="default">已知噪音</Tag>;
  return <Tag color="orange">⚠ 白名單外</Tag>;
}

const RadarSection: React.FC<Props> = ({ radar }) => {
  const [showNoise, setShowNoise] = useState(false);

  const all = radar || [];
  const filtered = showNoise ? all : all.filter((r) => !r.isNoise);
  const noiseCount = all.filter((r) => r.isNoise).length;

  const columns: ColumnsType<ObserveRadarEntry> = [
    { title: '表名', dataIndex: 'table', key: 'table', render: (v: string) => <span className="font-mono">{v}</span> },
    { title: '新增', dataIndex: 'inserts', key: 'inserts', width: 80, align: 'center' },
    { title: '更新', dataIndex: 'updates', key: 'updates', width: 80, align: 'center' },
    { title: '刪除', dataIndex: 'deletes', key: 'deletes', width: 80, align: 'center' },
    { title: '標記', key: 'mark', width: 120, render: (_: unknown, record: ObserveRadarEntry) => renderMark(record) },
  ];

  return (
    <Collapse
      items={[
        {
          key: 'radar',
          label: `全域雷達（pg_stat diff）— ${all.length} 張表`,
          children: (
            <div>
              <div className="flex items-center gap-3 mb-3">
                <Checkbox checked={showNoise} onChange={(e) => setShowNoise(e.target.checked)}>
                  顯示已知噪音
                </Checkbox>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  已過濾 {showNoise ? 0 : noiseCount} 張噪音表
                </Text>
              </div>
              <Table<ObserveRadarEntry>
                dataSource={filtered}
                columns={columns}
                rowKey="table"
                size="small"
                pagination={{ pageSize: 20, showSizeChanger: false }}
              />
            </div>
          ),
        },
      ]}
    />
  );
};

export default RadarSection;
